import {z} from "@otto-ec/global-resources/zod";
import {type FirebasePayload} from "../firebasePayload";

export const firebasePayloadSchema = z.object({
    event_name: z
        .string({
            error: "event_name is required and must be a non-empty string",
        })
        .refine((val) => val.trim().length > 0, {
            message: "event_name is required and must be a non-empty string",
        }),

    event_params: z.looseObject(
        {
            items: z
                .array(
                    z.looseObject({},
                        {error: "expected object but was different type"}
                    ),
                    {error: "expected array but was string"})
                .optional(),
        },
        {error: "event_params is required and must be an object"},
    )
});

export type ParsedFirebasePayload = z.infer<typeof firebasePayloadSchema>;

type FirebaseParseResult =
    | { data: ParsedFirebasePayload }
    | { validation_error: Record<string, string> };

export const firebasePayloadFromObject = async function (
    payload: FirebasePayload,
): Promise<FirebaseParseResult> {
    const result = await firebasePayloadSchema.safeParseAsync(payload);

    if (!result.success) {
        const formatted: Record<string, string> = {};

        for (const issue of result.error.issues) {
            const path = issue.path.join(".");
            formatted[path] = issue.message;
        }

        return {validation_error: formatted};
    }

    return {data: result.data};
};
